import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=6d07c3e0&scoped=true&"
import script from "./videoDialog.vue?vue&type=script&lang=js&"
export * from "./videoDialog.vue?vue&type=script&lang=js&"
import style0 from "./videoDialog.vue?vue&type=style&index=0&id=6d07c3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d07c3e0",
  null
  
)

export default component.exports